<template>
  <div class="boss-page">
    <van-nav-bar title="公司月度汇总" left-arrow @click-left="$router.back()"/>
    <section class="filter">
      <button v-for="item in types" :key="item.value" :class="{active:cadence===item.value}" @click="cadence=item.value;load()">{{ item.label }}
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="10"/>
    <main v-else>
      <article class="headline"><small>{{ data.periodLabel }}</small>
        <h1>公司绩效 {{ num(data.summary && data.summary.averageScore) }} 分</h1>
        <p>提交率 {{ num(data.summary && data.summary.submissionRate) }}% · 达标率 {{ num(data.summary && data.summary.targetRate) }}%</p></article>
      <h2>绩效趋势</h2>
      <article v-for="item in data.trends||[]" :key="item.month" class="trend"><b>{{ item.month }}</b><span><i
        :style="{width:Math.min(100,Number(item.averageScore||0))+'%'}"></i></span><strong>{{ num(item.averageScore) }}</strong></article>
      <h2>本期亮点</h2>
      <article v-for="item in data.highlights||[]" :key="item">{{ item }}</article>
      <h2>风险关注</h2>
      <article v-for="item in data.risks||[]" :key="item" class="risk">{{ item }}</article>
      <van-empty v-if="!(data.highlights||[]).length&&!(data.risks||[]).length" description="本期暂无可生成内容"/>
    </main>
  </div>
</template>
<script>
/**
 * Boss 公司汇总报告：周/月/季 cadence 切换，展示趋势、亮点与风险。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {
      month: this.$route.query.month || `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      cadence: 'MONTHLY',
      types: [{label: '周汇总', value: 'WEEKLY'}, {label: '月汇总', value: 'MONTHLY'}, {label: '季汇总', value: 'QUARTERLY'}],
      data: {},
      loading: false
    }
  }, mounted() {
    this.load()
  }, methods: {
    num(v) {
      return Number(v || 0).toFixed(1)
    }, async load() {
      this.loading = true;
      try {
        this.data = await coreapi.bossReport(this.month, this.cadence)
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}</script>
<style lang="less" scoped>@import './boss.less';

main h2 {
  margin: .28rem 0 .16rem;
  color: #34364a;
  font-size: .31rem
}

.headline {
  color: #fff;
  background: linear-gradient(145deg, #D32F2F, #B71C1C) !important
}

.headline small {
  opacity: .82
}

.headline h1 {
  margin: .12rem 0;
  font-size: .44rem
}

.trend {
  display: flex;
  align-items: center
}

.trend > b {
  width: 1.25rem
}

.trend span {
  height: .16rem;
  flex: 1;
  overflow: hidden;
  border-radius: .08rem;
  background: #f0f0f0
}

.trend i {
  height: 100%;
  display: block;
  border-radius: .08rem;
  background: @color
}

.trend strong {
  width: .75rem;
  text-align: right;
  color: @color
}

.risk {
  color: #a64040;
  border-left: .06rem solid #D32F2F
}</style>



// WEBPACK FOOTER //
// src/views/boss/Report.vue